function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e17) { throw _e17; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e18) { didErr = true; err = _e18; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function e(e, t, s) {
  return t in e ? Object.defineProperty(e, t, {
    value: s,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = s, e;
}
var t = "undefined" != typeof self ? self : global;
var s = "undefined" != typeof navigator,
  i = s && "undefined" == typeof HTMLImageElement,
  n = !("undefined" == typeof global || "undefined" == typeof process || !process.versions || !process.versions.node),
  r = t.Buffer,
  a = !!r,
  h = function h(e) {
    return void 0 !== e;
  };
function f(e) {
  return void 0 === e || (e instanceof Map ? 0 === e.size : 0 === Object.values(e).filter(h).length);
}
function l(e) {
  var t = new Error(e);
  throw delete t.stack, t;
}
function o(e) {
  var t = function (e) {
    var t = 0;
    return e.ifd0.enabled && (t += 1024), e.exif.enabled && (t += 2048), e.makerNote && (t += 2048), e.userComment && (t += 1024), e.gps.enabled && (t += 512), e.interop.enabled && (t += 100), e.ifd1.enabled && (t += 1024), t + 2048;
  }(e);
  return e.jfif.enabled && (t += 50), e.xmp.enabled && (t += 2e4), e.iptc.enabled && (t += 14e3), e.icc.enabled && (t += 6e3), t;
}
var u = function u(e) {
    return String.fromCharCode.apply(null, e);
  },
  d = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : void 0;
var c = /*#__PURE__*/function () {
  function c(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var s = arguments.length > 2 ? arguments[2] : undefined;
    var i = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, c);
    if ("boolean" == typeof i && (this.le = i), Array.isArray(e) && (e = new Uint8Array(e)), 0 === e) this.byteOffset = 0, this.byteLength = 0;else if (e instanceof ArrayBuffer) {
      void 0 === s && (s = e.byteLength - t);
      var _i = new DataView(e, t, s);
      this._swapDataView(_i);
    } else if (e instanceof Uint8Array || e instanceof DataView || e instanceof c) {
      void 0 === s && (s = e.byteLength - t), (t += e.byteOffset) + s > e.byteOffset + e.byteLength && l("Creating view outside of available memory in ArrayBuffer");
      var _i2 = new DataView(e.buffer, t, s);
      this._swapDataView(_i2);
    } else if ("number" == typeof e) {
      var _t = new DataView(new ArrayBuffer(e));
      this._swapDataView(_t);
    } else l("Invalid input argument for BufferView: " + e);
  }
  _createClass(c, [{
    key: "_swapArrayBuffer",
    value: function _swapArrayBuffer(e) {
      this._swapDataView(new DataView(e));
    }
  }, {
    key: "_swapBuffer",
    value: function _swapBuffer(e) {
      this._swapDataView(new DataView(e.buffer, e.byteOffset, e.byteLength));
    }
  }, {
    key: "_swapDataView",
    value: function _swapDataView(e) {
      this.dataView = e, this.buffer = e.buffer, this.byteOffset = e.byteOffset, this.byteLength = e.byteLength;
    }
  }, {
    key: "_lengthToEnd",
    value: function _lengthToEnd(e) {
      return this.byteLength - e;
    }
  }, {
    key: "set",
    value: function set(e, t) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : c;
      return e instanceof DataView || e instanceof c ? e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : e instanceof ArrayBuffer && (e = new Uint8Array(e)), e instanceof Uint8Array || l("BufferView.set(): Invalid data argument."), this.toUint8().set(e, t), new s(this, t, e.byteLength);
    }
  }, {
    key: "subarray",
    value: function subarray(e, t) {
      return t = t || this._lengthToEnd(e), new c(this, e, t);
    }
  }, {
    key: "toUint8",
    value: function toUint8() {
      return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
    }
  }, {
    key: "getUint8Array",
    value: function getUint8Array(e, t) {
      return new Uint8Array(this.buffer, this.byteOffset + e, t);
    }
  }, {
    key: "getString",
    value: function getString() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.byteLength;
      var s = this.getUint8Array(e, t);
      return i = s, d ? d.decode(i) : a ? Buffer.from(i).toString("utf8") : decodeURIComponent(escape(u(i)));
      var i;
    }
  }, {
    key: "getLatin1String",
    value: function getLatin1String() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.byteLength;
      var s = this.getUint8Array(e, t);
      return u(s);
    }
  }, {
    key: "getUnicodeString",
    value: function getUnicodeString() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.byteLength;
      var s = [];
      for (var _i3 = 0; _i3 < t && e + _i3 < this.byteLength; _i3 += 2) s.push(this.getUint16(e + _i3));
      return u(s);
    }
  }, {
    key: "getInt8",
    value: function getInt8(e) {
      return this.dataView.getInt8(e);
    }
  }, {
    key: "getUint8",
    value: function getUint8(e) {
      return this.dataView.getUint8(e);
    }
  }, {
    key: "getInt16",
    value: function getInt16(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getInt16(e, t);
    }
  }, {
    key: "getInt32",
    value: function getInt32(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getInt32(e, t);
    }
  }, {
    key: "getUint16",
    value: function getUint16(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getUint16(e, t);
    }
  }, {
    key: "getUint32",
    value: function getUint32(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getUint32(e, t);
    }
  }, {
    key: "getFloat32",
    value: function getFloat32(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getFloat32(e, t);
    }
  }, {
    key: "getFloat64",
    value: function getFloat64(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getFloat64(e, t);
    }
  }, {
    key: "getFloat",
    value: function getFloat(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getFloat32(e, t);
    }
  }, {
    key: "getDouble",
    value: function getDouble(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.le;
      return this.dataView.getFloat64(e, t);
    }
  }, {
    key: "getUintBytes",
    value: function getUintBytes(e, t, s) {
      switch (t) {
        case 1:
          return this.getUint8(e, s);
        case 2:
          return this.getUint16(e, s);
        case 4:
          return this.getUint32(e, s);
        case 8:
          return this.getUint64 && this.getUint64(e, s);
      }
    }
  }, {
    key: "getUint",
    value: function getUint(e, t, s) {
      switch (t) {
        case 8:
          return this.getUint8(e, s);
        case 16:
          return this.getUint16(e, s);
        case 32:
          return this.getUint32(e, s);
        case 64:
          return this.getUint64 && this.getUint64(e, s);
      }
    }
  }, {
    key: "toString",
    value: function toString(e) {
      return this.dataView.toString(e, this.constructor.name);
    }
  }, {
    key: "ensureChunk",
    value: function ensureChunk() {}
  }], [{
    key: "from",
    value: function from(e, t) {
      return e instanceof this && e.le === t ? e : new c(e, void 0, void 0, t);
    }
  }]);
  return c;
}();
function p(e, t) {
  l("".concat(e, " '").concat(t, "' was not loaded, try using full build of exifr."));
}
var g = /*#__PURE__*/function (_Map) {
  _inherits(g, _Map);
  function g(e) {
    var _this;
    _classCallCheck(this, g);
    _this = _callSuper(this, g), _this.kind = e;
    return _this;
  }
  _createClass(g, [{
    key: "get",
    value: function get(e, t) {
      return this.has(e) || p(this.kind, e), t && (e in t || function (e, t) {
        l("Unknown ".concat(e, " '").concat(t, "'."));
      }(this.kind, e), t[e].enabled || p(this.kind, e)), _get(_getPrototypeOf(g.prototype), "get", this).call(this, e);
    }
  }, {
    key: "keyList",
    value: function keyList() {
      return Array.from(this.keys());
    }
  }]);
  return g;
}( /*#__PURE__*/_wrapNativeSuper(Map));
var m = new g("file parser"),
  y = new g("segment parser"),
  b = new g("file reader");
var w = t.fetch;
function k(e, t) {
  return (i = e).startsWith("data:") || i.length > 1e4 ? v(e, t, "base64") : n && e.includes("://") ? O(e, t, "url", S) : n ? v(e, t, "fs") : s ? O(e, t, "url", S) : void l("Invalid input argument");
  var i;
}
function O(_x, _x2, _x3, _x4) {
  return _O.apply(this, arguments);
}
function _O() {
  _O = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(e, t, s, i) {
    return _regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          return _context26.abrupt("return", b.has(s) ? v(e, t, s) : i ? function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(e, t) {
              var s;
              return _regeneratorRuntime().wrap(function _callee25$(_context25) {
                while (1) switch (_context25.prev = _context25.next) {
                  case 0:
                    _context25.next = 2;
                    return t(e);
                  case 2:
                    s = _context25.sent;
                    return _context25.abrupt("return", new c(s));
                  case 4:
                  case "end":
                    return _context25.stop();
                }
              }, _callee25);
            }));
            return function (_x26, _x27) {
              return _ref8.apply(this, arguments);
            };
          }()(e, i) : void l("Parser ".concat(s, " is not loaded")));
        case 1:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return _O.apply(this, arguments);
}
function v(_x5, _x6, _x7) {
  return _v.apply(this, arguments);
}
function _v() {
  _v = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(e, t, s) {
    var i;
    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          i = new (b.get(s))(e, t);
          _context27.next = 3;
          return i.read();
        case 3:
          return _context27.abrupt("return", i);
        case 4:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return _v.apply(this, arguments);
}
var S = function S(e) {
    return w(e).then(function (e) {
      return e.arrayBuffer();
    });
  },
  A = function A(e) {
    return new Promise(function (t, s) {
      var i = new FileReader();
      i.onloadend = function () {
        return t(i.result || new ArrayBuffer());
      }, i.onerror = s, i.readAsArrayBuffer(e);
    });
  };
var U = /*#__PURE__*/function (_Map2) {
  _inherits(U, _Map2);
  function U() {
    _classCallCheck(this, U);
    return _callSuper(this, U, arguments);
  }
  _createClass(U, [{
    key: "tagKeys",
    get: function get() {
      return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
    }
  }, {
    key: "tagValues",
    get: function get() {
      return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
    }
  }]);
  return U;
}( /*#__PURE__*/_wrapNativeSuper(Map));
function x(e, t, s) {
  var i = new U();
  var _iterator = _createForOfIteratorHelper(s),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        _e = _step$value[0],
        _t2 = _step$value[1];
      i.set(_e, _t2);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (Array.isArray(t)) {
    var _iterator2 = _createForOfIteratorHelper(t),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _s = _step2.value;
        e.set(_s, i);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  } else e.set(t, i);
  return i;
}
function C(e, t, s) {
  var i,
    n = e.get(t);
  var _iterator3 = _createForOfIteratorHelper(s),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      i = _step3.value;
      n.set(i[0], i[1]);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}
var B = new Map(),
  V = new Map(),
  I = new Map(),
  L = ["chunked", "firstChunkSize", "firstChunkSizeNode", "firstChunkSizeBrowser", "chunkSize", "chunkLimit"],
  T = ["jfif", "xmp", "icc", "iptc", "ihdr"],
  z = ["tiff"].concat(T),
  P = ["ifd0", "ifd1", "exif", "gps", "interop"],
  F = [].concat(_toConsumableArray(z), P),
  j = ["makerNote", "userComment"],
  E = ["translateKeys", "translateValues", "reviveValues", "multiSegment"],
  M = [].concat(E, ["sanitize", "mergeOutput", "silentErrors"]);
var _ = /*#__PURE__*/function () {
  function _() {
    _classCallCheck(this, _);
  }
  _createClass(_, [{
    key: "translate",
    get: function get() {
      return this.translateKeys || this.translateValues || this.reviveValues;
    }
  }]);
  return _;
}();
var D = /*#__PURE__*/function (_ref) {
  _inherits(D, _ref);
  function D(t, s, i, n) {
    var _this2;
    _classCallCheck(this, D);
    if (_this2 = _callSuper(this, D), e(_assertThisInitialized(_this2), "enabled", !1), e(_assertThisInitialized(_this2), "skip", new Set()), e(_assertThisInitialized(_this2), "pick", new Set()), e(_assertThisInitialized(_this2), "deps", new Set()), e(_assertThisInitialized(_this2), "translateKeys", !1), e(_assertThisInitialized(_this2), "translateValues", !1), e(_assertThisInitialized(_this2), "reviveValues", !1), _this2.key = t, _this2.enabled = s, _this2.parse = _this2.enabled, _this2.applyInheritables(n), _this2.canBeFiltered = P.includes(t), _this2.canBeFiltered && (_this2.dict = B.get(t)), void 0 !== i) if (Array.isArray(i)) _this2.parse = _this2.enabled = !0, _this2.canBeFiltered && i.length > 0 && _this2.translateTagSet(i, _this2.pick);else if ("object" == _typeof(i)) {
      if (_this2.enabled = !0, _this2.parse = !1 !== i.parse, _this2.canBeFiltered) {
        var _e2 = i.pick,
          _t3 = i.skip;
        _e2 && _e2.length > 0 && _this2.translateTagSet(_e2, _this2.pick), _t3 && _t3.length > 0 && _this2.translateTagSet(_t3, _this2.skip);
      }
      _this2.applyInheritables(i);
    } else !0 === i || !1 === i ? _this2.parse = _this2.enabled = i : l("Invalid options argument: ".concat(i));
    return _possibleConstructorReturn(_this2);
  }
  _createClass(D, [{
    key: "needed",
    get: function get() {
      return this.enabled || this.deps.size > 0;
    }
  }, {
    key: "applyInheritables",
    value: function applyInheritables(e) {
      var t, s;
      for (var _i4 = 0, _E = E; _i4 < _E.length; _i4++) {
        t = _E[_i4];
        s = e[t], void 0 !== s && (this[t] = s);
      }
    }
  }, {
    key: "translateTagSet",
    value: function translateTagSet(e, t) {
      if (this.dict) {
        var _s2,
          _i5,
          _this$dict = this.dict,
          _n = _this$dict.tagKeys,
          _r = _this$dict.tagValues;
        var _iterator4 = _createForOfIteratorHelper(e),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            _s2 = _step4.value;
            "string" == typeof _s2 ? (_i5 = _r.indexOf(_s2), -1 === _i5 && (_i5 = _n.indexOf(Number(_s2))), -1 !== _i5 && t.add(Number(_n[_i5]))) : t.add(_s2);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } else {
        var _iterator5 = _createForOfIteratorHelper(e),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _s3 = _step5.value;
            t.add(_s3);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  }, {
    key: "finalizeFilters",
    value: function finalizeFilters() {
      !this.enabled && this.deps.size > 0 ? (this.enabled = !0, X(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && X(this.pick, this.deps);
    }
  }]);
  return D;
}(_);
var N = {
    jfif: !1,
    tiff: !0,
    xmp: !1,
    icc: !1,
    iptc: !1,
    ifd0: !0,
    ifd1: !1,
    exif: !0,
    gps: !0,
    interop: !1,
    ihdr: void 0,
    makerNote: !1,
    userComment: !1,
    multiSegment: !1,
    skip: [],
    pick: [],
    translateKeys: !0,
    translateValues: !0,
    reviveValues: !0,
    sanitize: !0,
    mergeOutput: !0,
    silentErrors: !0,
    chunked: !0,
    firstChunkSize: void 0,
    firstChunkSizeNode: 512,
    firstChunkSizeBrowser: 65536,
    chunkSize: 65536,
    chunkLimit: 5
  },
  $ = new Map();
var R = /*#__PURE__*/function (_ref2) {
  _inherits(R, _ref2);
  function R(e) {
    var _this3;
    _classCallCheck(this, R);
    _this3 = _callSuper(this, R), !0 === e ? _this3.setupFromTrue() : void 0 === e ? _this3.setupFromUndefined() : Array.isArray(e) ? _this3.setupFromArray(e) : "object" == _typeof(e) ? _this3.setupFromObject(e) : l("Invalid options argument ".concat(e)), void 0 === _this3.firstChunkSize && (_this3.firstChunkSize = s ? _this3.firstChunkSizeBrowser : _this3.firstChunkSizeNode), _this3.mergeOutput && (_this3.ifd1.enabled = !1), _this3.filterNestedSegmentTags(), _this3.traverseTiffDependencyTree(), _this3.checkLoadedPlugins();
    return _this3;
  }
  _createClass(R, [{
    key: "setupFromUndefined",
    value: function setupFromUndefined() {
      var e;
      for (var _i6 = 0, _L = L; _i6 < _L.length; _i6++) {
        e = _L[_i6];
        this[e] = N[e];
      }
      var _iterator6 = _createForOfIteratorHelper(M),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          e = _step6.value;
          this[e] = N[e];
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      for (var _i7 = 0, _j = j; _i7 < _j.length; _i7++) {
        e = _j[_i7];
        this[e] = N[e];
      }
      var _iterator7 = _createForOfIteratorHelper(F),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          e = _step7.value;
          this[e] = new D(e, N[e], void 0, this);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "setupFromTrue",
    value: function setupFromTrue() {
      var e;
      for (var _i8 = 0, _L2 = L; _i8 < _L2.length; _i8++) {
        e = _L2[_i8];
        this[e] = N[e];
      }
      var _iterator8 = _createForOfIteratorHelper(M),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          e = _step8.value;
          this[e] = N[e];
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      for (var _i9 = 0, _j2 = j; _i9 < _j2.length; _i9++) {
        e = _j2[_i9];
        this[e] = !0;
      }
      var _iterator9 = _createForOfIteratorHelper(F),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          e = _step9.value;
          this[e] = new D(e, !0, void 0, this);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }, {
    key: "setupFromArray",
    value: function setupFromArray(e) {
      var t;
      for (var _i10 = 0, _L3 = L; _i10 < _L3.length; _i10++) {
        t = _L3[_i10];
        this[t] = N[t];
      }
      var _iterator10 = _createForOfIteratorHelper(M),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          t = _step10.value;
          this[t] = N[t];
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      for (var _i11 = 0, _j3 = j; _i11 < _j3.length; _i11++) {
        t = _j3[_i11];
        this[t] = N[t];
      }
      var _iterator11 = _createForOfIteratorHelper(F),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          t = _step11.value;
          this[t] = new D(t, !1, void 0, this);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      this.setupGlobalFilters(e, void 0, P);
    }
  }, {
    key: "setupFromObject",
    value: function setupFromObject(e) {
      var t;
      for (var _i12 = 0, _arr = (P.ifd0 = P.ifd0 || P.image, P.ifd1 = P.ifd1 || P.thumbnail, Object.assign(this, e), L); _i12 < _arr.length; _i12++) {
        t = _arr[_i12];
        this[t] = W(e[t], N[t]);
      }
      var _iterator12 = _createForOfIteratorHelper(M),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          t = _step12.value;
          this[t] = W(e[t], N[t]);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      for (var _i13 = 0, _j4 = j; _i13 < _j4.length; _i13++) {
        t = _j4[_i13];
        this[t] = W(e[t], N[t]);
      }
      var _iterator13 = _createForOfIteratorHelper(z),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          t = _step13.value;
          this[t] = new D(t, N[t], e[t], this);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      for (var _i14 = 0, _P = P; _i14 < _P.length; _i14++) {
        t = _P[_i14];
        this[t] = new D(t, N[t], e[t], this.tiff);
      }
      this.setupGlobalFilters(e.pick, e.skip, P, F), !0 === e.tiff ? this.batchEnableWithBool(P, !0) : !1 === e.tiff ? this.batchEnableWithUserValue(P, e) : Array.isArray(e.tiff) ? this.setupGlobalFilters(e.tiff, void 0, P) : "object" == _typeof(e.tiff) && this.setupGlobalFilters(e.tiff.pick, e.tiff.skip, P);
    }
  }, {
    key: "batchEnableWithBool",
    value: function batchEnableWithBool(e, t) {
      var _iterator14 = _createForOfIteratorHelper(e),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var _s4 = _step14.value;
          this[_s4].enabled = t;
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }
  }, {
    key: "batchEnableWithUserValue",
    value: function batchEnableWithUserValue(e, t) {
      var _iterator15 = _createForOfIteratorHelper(e),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var _s5 = _step15.value;
          var _e3 = t[_s5];
          this[_s5].enabled = !1 !== _e3 && void 0 !== _e3;
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
    }
  }, {
    key: "setupGlobalFilters",
    value: function setupGlobalFilters(e, t, s) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : s;
      if (e && e.length) {
        var _iterator16 = _createForOfIteratorHelper(i),
          _step16;
        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var _e4 = _step16.value;
            this[_e4].enabled = !1;
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
        var _t4 = K(e, s);
        var _iterator17 = _createForOfIteratorHelper(_t4),
          _step17;
        try {
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            var _step17$value = _slicedToArray(_step17.value, 2),
              _e5 = _step17$value[0],
              _s6 = _step17$value[1];
            X(this[_e5].pick, _s6), this[_e5].enabled = !0;
          }
        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }
      } else if (t && t.length) {
        var _e6 = K(t, s);
        var _iterator18 = _createForOfIteratorHelper(_e6),
          _step18;
        try {
          for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
            var _step18$value = _slicedToArray(_step18.value, 2),
              _t5 = _step18$value[0],
              _s7 = _step18$value[1];
            X(this[_t5].skip, _s7);
          }
        } catch (err) {
          _iterator18.e(err);
        } finally {
          _iterator18.f();
        }
      }
    }
  }, {
    key: "filterNestedSegmentTags",
    value: function filterNestedSegmentTags() {
      var e = this.ifd0,
        t = this.exif,
        s = this.xmp,
        i = this.iptc,
        n = this.icc;
      this.makerNote ? t.deps.add(37500) : t.skip.add(37500), this.userComment ? t.deps.add(37510) : t.skip.add(37510), s.enabled || e.skip.add(700), i.enabled || e.skip.add(33723), n.enabled || e.skip.add(34675);
    }
  }, {
    key: "traverseTiffDependencyTree",
    value: function traverseTiffDependencyTree() {
      var _this4 = this;
      var e = this.ifd0,
        t = this.exif,
        s = this.gps,
        i = this.interop;
      i.needed && (t.deps.add(40965), e.deps.add(40965)), t.needed && e.deps.add(34665), s.needed && e.deps.add(34853), this.tiff.enabled = P.some(function (e) {
        return !0 === _this4[e].enabled;
      }) || this.makerNote || this.userComment;
      for (var _i15 = 0, _P2 = P; _i15 < _P2.length; _i15++) {
        var _e7 = _P2[_i15];
        this[_e7].finalizeFilters();
      }
    }
  }, {
    key: "onlyTiff",
    get: function get() {
      var _this5 = this;
      return !T.map(function (e) {
        return _this5[e].enabled;
      }).some(function (e) {
        return !0 === e;
      }) && this.tiff.enabled;
    }
  }, {
    key: "checkLoadedPlugins",
    value: function checkLoadedPlugins() {
      var _iterator19 = _createForOfIteratorHelper(z),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _e8 = _step19.value;
          this[_e8].enabled && !y.has(_e8) && p("segment parser", _e8);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
    }
  }], [{
    key: "useCached",
    value: function useCached(e) {
      var t = $.get(e);
      return void 0 !== t || (t = new this(e), $.set(e, t)), t;
    }
  }]);
  return R;
}(_);
function K(e, t) {
  var s,
    i,
    n,
    r,
    a = [];
  var _iterator20 = _createForOfIteratorHelper(t),
    _step20;
  try {
    for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
      n = _step20.value;
      var _iterator21 = _createForOfIteratorHelper((s = B.get(n), i = [], s)),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          r = _step21.value;
          (e.includes(r[0]) || e.includes(r[1])) && i.push(r[0]);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
      i.length && a.push([n, i]);
    }
  } catch (err) {
    _iterator20.e(err);
  } finally {
    _iterator20.f();
  }
  return a;
}
function W(e, t) {
  return void 0 !== e ? e : void 0 !== t ? t : void 0;
}
function X(e, t) {
  var _iterator22 = _createForOfIteratorHelper(t),
    _step22;
  try {
    for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
      var _s8 = _step22.value;
      e.add(_s8);
    }
  } catch (err) {
    _iterator22.e(err);
  } finally {
    _iterator22.f();
  }
}
e(R, "default", N);
var H = /*#__PURE__*/function () {
  function H(t) {
    var _this6 = this;
    _classCallCheck(this, H);
    e(this, "parsers", {}), e(this, "output", {}), e(this, "errors", []), e(this, "pushToErrors", function (e) {
      return _this6.errors.push(e);
    }), this.options = R.useCached(t);
  }
  _createClass(H, [{
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return function (e, t) {
                return "string" == typeof e ? k(e, t) : s && !i && e instanceof HTMLImageElement ? k(e.src, t) : e instanceof Uint8Array || e instanceof ArrayBuffer || e instanceof DataView ? new c(e) : s && e instanceof Blob ? O(e, t, "blob", A) : void l("Invalid input argument");
              }(e, this.options);
            case 2:
              this.file = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function read(_x8) {
        return _read.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "setup",
    value: function setup() {
      if (this.fileParser) return;
      var e = this.file,
        t = e.getUint16(0);
      var _iterator23 = _createForOfIteratorHelper(m),
        _step23;
      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var _step23$value = _slicedToArray(_step23.value, 2),
            _s9 = _step23$value[0],
            _i16 = _step23$value[1];
          if (_i16.canHandle(e, t)) return this.fileParser = new _i16(this.options, this.file, this.parsers), e[_s9] = !0;
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
      this.file.close && this.file.close(), l("Unknown file format");
    }
  }, {
    key: "parse",
    value: function () {
      var _parse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var e, t, s;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              e = this.output, t = this.errors;
              this.setup();
              if (!this.options.silentErrors) {
                _context2.next = 8;
                break;
              }
              _context2.next = 5;
              return this.executeParsers().catch(this.pushToErrors);
            case 5:
              t.push.apply(t, _toConsumableArray(this.fileParser.errors));
              _context2.next = 10;
              break;
            case 8:
              _context2.next = 10;
              return this.executeParsers();
            case 10:
              this.file.close && this.file.close();
              this.options.silentErrors && t.length > 0 && (e.errors = t);
              return _context2.abrupt("return", f(s = e) ? void 0 : s);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function parse() {
        return _parse.apply(this, arguments);
      }
      return parse;
    }()
  }, {
    key: "executeParsers",
    value: function () {
      var _executeParsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this7 = this;
        var e, t;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              e = this.output;
              _context4.next = 3;
              return this.fileParser.parse();
            case 3:
              t = Object.values(this.parsers).map( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(t) {
                  var s;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return t.parse();
                      case 2:
                        s = _context3.sent;
                        t.assignToOutput(e, s);
                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x9) {
                  return _ref3.apply(this, arguments);
                };
              }());
              this.options.silentErrors && (t = t.map(function (e) {
                return e.catch(_this7.pushToErrors);
              }));
              _context4.next = 7;
              return Promise.all(t);
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function executeParsers() {
        return _executeParsers.apply(this, arguments);
      }
      return executeParsers;
    }()
  }, {
    key: "extractThumbnail",
    value: function () {
      var _extractThumbnail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var e, t, s, i, n, r, a;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.setup();
              e = this.options, t = this.file, s = y.get("tiff", e);
              if (!t.tiff) {
                _context5.next = 6;
                break;
              }
              i = {
                start: 0,
                type: "tiff"
              };
              _context5.next = 11;
              break;
            case 6:
              _context5.t0 = t.jpeg;
              if (!_context5.t0) {
                _context5.next = 11;
                break;
              }
              _context5.next = 10;
              return this.fileParser.getOrFindSegment("tiff");
            case 10:
              i = _context5.sent;
            case 11:
              if (!(void 0 === i)) {
                _context5.next = 13;
                break;
              }
              return _context5.abrupt("return");
            case 13:
              _context5.next = 15;
              return this.fileParser.ensureSegmentChunk(i);
            case 15:
              n = _context5.sent;
              r = this.parsers.tiff = new s(n, e, t);
              _context5.next = 19;
              return r.extractThumbnail();
            case 19:
              a = _context5.sent;
              return _context5.abrupt("return", (t.close && t.close(), a));
            case 21:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function extractThumbnail() {
        return _extractThumbnail.apply(this, arguments);
      }
      return extractThumbnail;
    }()
  }]);
  return H;
}();
function Y(_x10, _x11) {
  return _Y.apply(this, arguments);
}
function _Y() {
  _Y = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(e, t) {
    var s;
    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          s = new H(t);
          _context28.next = 3;
          return s.read(e);
        case 3:
          return _context28.abrupt("return", s.parse());
        case 4:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return _Y.apply(this, arguments);
}
var G = Object.freeze({
  __proto__: null,
  parse: Y,
  Exifr: H,
  fileParsers: m,
  segmentParsers: y,
  fileReaders: b,
  tagKeys: B,
  tagValues: V,
  tagRevivers: I,
  createDictionary: x,
  extendDictionary: C,
  fetchUrlAsArrayBuffer: S,
  readBlobAsArrayBuffer: A,
  chunkedProps: L,
  otherSegments: T,
  segments: z,
  tiffBlocks: P,
  segmentsAndBlocks: F,
  tiffExtractables: j,
  inheritables: E,
  allFormatters: M,
  Options: R
});
var J = /*#__PURE__*/function () {
  function J(t) {
    var _this8 = this;
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, J);
    e(this, "errors", []), e(this, "raw", new Map()), e(this, "handleError", function (e) {
      if (!_this8.options.silentErrors) throw e;
      _this8.errors.push(e.message);
    }), this.chunk = this.normalizeInput(t), this.file = i, this.type = this.constructor.type, this.globalOptions = this.options = s, this.localOptions = s[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
  }
  _createClass(J, [{
    key: "normalizeInput",
    value: function normalizeInput(e) {
      return e instanceof c ? e : new c(e);
    }
  }, {
    key: "translate",
    value: function translate() {
      this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
    }
  }, {
    key: "output",
    get: function get() {
      return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
    }
  }, {
    key: "translateBlock",
    value: function translateBlock(e, t) {
      var s = I.get(t),
        i = V.get(t),
        n = B.get(t),
        r = this.options[t],
        a = r.reviveValues && !!s,
        h = r.translateValues && !!i,
        f = r.translateKeys && !!n,
        l = {};
      var _iterator24 = _createForOfIteratorHelper(e),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var _step24$value = _slicedToArray(_step24.value, 2),
            _t6 = _step24$value[0],
            _r2 = _step24$value[1];
          a && s.has(_t6) ? _r2 = s.get(_t6)(_r2) : h && i.has(_t6) && (_r2 = this.translateValue(_r2, i.get(_t6))), f && n.has(_t6) && (_t6 = n.get(_t6) || _t6), l[_t6] = _r2;
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      return l;
    }
  }, {
    key: "translateValue",
    value: function translateValue(e, t) {
      return t[e] || t.DEFAULT || e;
    }
  }, {
    key: "assignToOutput",
    value: function assignToOutput(e, t) {
      this.assignObjectToOutput(e, this.constructor.type, t);
    }
  }, {
    key: "assignObjectToOutput",
    value: function assignObjectToOutput(e, t, s) {
      if (this.globalOptions.mergeOutput) return Object.assign(e, s);
      e[t] ? Object.assign(e[t], s) : e[t] = s;
    }
  }], [{
    key: "findPosition",
    value: function findPosition(e, t) {
      var s = e.getUint16(t + 2) + 2,
        i = "function" == typeof this.headerLength ? this.headerLength(e, t, s) : this.headerLength,
        n = t + i,
        r = s - i;
      return {
        offset: t,
        length: s,
        headerLength: i,
        start: n,
        size: r,
        end: n + r
      };
    }
  }, {
    key: "parse",
    value: function parse(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new this(e, new R(_defineProperty({}, this.type, t)), e).parse();
    }
  }]);
  return J;
}();
e(J, "headerLength", 4), e(J, "type", void 0), e(J, "multiSegment", !1), e(J, "canHandle", function () {
  return !1;
});
function q(e) {
  return 192 === e || 194 === e || 196 === e || 219 === e || 221 === e || 218 === e || 254 === e;
}
function Q(e) {
  return e >= 224 && e <= 239;
}
function Z(e, t, s) {
  var _iterator25 = _createForOfIteratorHelper(y),
    _step25;
  try {
    for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
      var _step25$value = _slicedToArray(_step25.value, 2),
        i = _step25$value[0],
        _n2 = _step25$value[1];
      if (_n2.canHandle(e, t, s)) return i;
    }
  } catch (err) {
    _iterator25.e(err);
  } finally {
    _iterator25.f();
  }
}
var ee = /*#__PURE__*/function (_ref4) {
  _inherits(ee, _ref4);
  function ee() {
    var _this9;
    _classCallCheck(this, ee);
    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }
    _this9 = _callSuper(this, ee, [].concat(t)), e(_assertThisInitialized(_this9), "appSegments", []), e(_assertThisInitialized(_this9), "jpegSegments", []), e(_assertThisInitialized(_this9), "unknownSegments", []);
    return _this9;
  }
  _createClass(ee, [{
    key: "parse",
    value: function () {
      var _parse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.findAppSegments();
            case 2:
              _context6.next = 4;
              return this.readSegments(this.appSegments);
            case 4:
              this.mergeMultiSegments();
              this.createParsers(this.mergedAppSegments || this.appSegments);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function parse() {
        return _parse2.apply(this, arguments);
      }
      return parse;
    }()
  }, {
    key: "setupSegmentFinderArgs",
    value: function setupSegmentFinderArgs(e) {
      var _this10 = this;
      !0 === e ? (this.findAll = !0, this.wanted = new Set(y.keyList())) : (e = void 0 === e ? y.keyList().filter(function (e) {
        return _this10.options[e].enabled;
      }) : e.filter(function (e) {
        return _this10.options[e].enabled && y.has(e);
      }), this.findAll = !1, this.remaining = new Set(e), this.wanted = new Set(e)), this.unfinishedMultiSegment = !1;
    }
  }, {
    key: "findAppSegments",
    value: function () {
      var _findAppSegments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this11 = this;
        var e,
          t,
          s,
          i,
          n,
          r,
          _t7,
          _i17,
          _n3,
          _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              e = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : 0;
              t = _args7.length > 1 ? _args7[1] : undefined;
              this.setupSegmentFinderArgs(t);
              s = this.file, i = this.findAll, n = this.wanted, r = this.remaining;
              _context7.t0 = !i && this.file.chunked;
              if (!_context7.t0) {
                _context7.next = 11;
                break;
              }
              i = Array.from(n).some(function (e) {
                var t = y.get(e),
                  s = _this11.options[e];
                return t.multiSegment && s.multiSegment;
              });
              _context7.t1 = i;
              if (!_context7.t1) {
                _context7.next = 11;
                break;
              }
              _context7.next = 11;
              return this.file.readWhole();
            case 11:
              e = this.findAppSegmentsInRange(e, s.byteLength);
              if (!(!this.options.onlyTiff && s.chunked)) {
                _context7.next = 30;
                break;
              }
              _t7 = !1;
            case 14:
              if (!(r.size > 0 && !_t7 && (s.canReadNextChunk || this.unfinishedMultiSegment))) {
                _context7.next = 30;
                break;
              }
              _i17 = s.nextChunkOffset, _n3 = this.appSegments.some(function (e) {
                return !_this11.file.available(e.offset || e.start, e.length || e.size);
              });
              if (!(e > _i17 && !_n3)) {
                _context7.next = 22;
                break;
              }
              _context7.next = 19;
              return s.readNextChunk(e);
            case 19:
              _context7.t2 = !_context7.sent;
              _context7.next = 25;
              break;
            case 22:
              _context7.next = 24;
              return s.readNextChunk(_i17);
            case 24:
              _context7.t2 = !_context7.sent;
            case 25:
              _t7 = _context7.t2;
              if (!(void 0 === (e = this.findAppSegmentsInRange(e, s.byteLength)))) {
                _context7.next = 28;
                break;
              }
              return _context7.abrupt("return");
            case 28:
              _context7.next = 14;
              break;
            case 30:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function findAppSegments() {
        return _findAppSegments.apply(this, arguments);
      }
      return findAppSegments;
    }()
  }, {
    key: "findAppSegmentsInRange",
    value: function findAppSegmentsInRange(e, t) {
      t -= 2;
      var s,
        i,
        n,
        r,
        a,
        h,
        f = this.file,
        l = this.findAll,
        o = this.wanted,
        u = this.remaining,
        d = this.options;
      for (; e < t; e++) if (255 === f.getUint8(e)) if (s = f.getUint8(e + 1), Q(s)) {
        if (i = f.getUint16(e + 2), n = Z(f, e, i), n && o.has(n) && (r = y.get(n), a = r.findPosition(f, e), h = d[n], a.type = n, this.appSegments.push(a), !l && (r.multiSegment && h.multiSegment ? (this.unfinishedMultiSegment = a.chunkNumber < a.chunkCount, this.unfinishedMultiSegment || u.delete(n)) : u.delete(n), 0 === u.size))) break;
        d.recordUnknownSegments && (a = J.findPosition(f, e), a.marker = s, this.unknownSegments.push(a)), e += i + 1;
      } else if (q(s)) {
        if (i = f.getUint16(e + 2), 218 === s && !1 !== d.stopAfterSos) return;
        d.recordJpegSegments && this.jpegSegments.push({
          offset: e,
          length: i,
          marker: s
        }), e += i + 1;
      }
      return e;
    }
  }, {
    key: "mergeMultiSegments",
    value: function mergeMultiSegments() {
      var _this12 = this;
      if (!this.appSegments.some(function (e) {
        return e.multiSegment;
      })) return;
      var e = function (e, t) {
        var s,
          i,
          n,
          r = new Map();
        for (var _a = 0; _a < e.length; _a++) s = e[_a], i = s[t], r.has(i) ? n = r.get(i) : r.set(i, n = []), n.push(s);
        return Array.from(r);
      }(this.appSegments, "type");
      this.mergedAppSegments = e.map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          e = _ref6[0],
          t = _ref6[1];
        var s = y.get(e, _this12.options);
        if (s.handleMultiSegments) {
          return {
            type: e,
            chunk: s.handleMultiSegments(t)
          };
        }
        return t[0];
      });
    }
  }, {
    key: "getSegment",
    value: function getSegment(e) {
      return this.appSegments.find(function (t) {
        return t.type === e;
      });
    }
  }, {
    key: "getOrFindSegment",
    value: function () {
      var _getOrFindSegment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
        var t;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              t = this.getSegment(e);
              _context8.t0 = void 0 === t;
              if (!_context8.t0) {
                _context8.next = 6;
                break;
              }
              _context8.next = 5;
              return this.findAppSegments(0, [e]);
            case 5:
              t = this.getSegment(e);
            case 6:
              return _context8.abrupt("return", t);
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getOrFindSegment(_x12) {
        return _getOrFindSegment.apply(this, arguments);
      }
      return getOrFindSegment;
    }()
  }], [{
    key: "canHandle",
    value: function canHandle(e, t) {
      return 65496 === t;
    }
  }]);
  return ee;
}( /*#__PURE__*/function () {
  function _class(t, s, i) {
    var _this13 = this;
    _classCallCheck(this, _class);
    e(this, "errors", []), e(this, "ensureSegmentChunk", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(e) {
        var t, s;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              t = e.start, s = e.size || 65536;
              if (!_this13.file.chunked) {
                _context9.next = 17;
                break;
              }
              if (!_this13.file.available(t, s)) {
                _context9.next = 6;
                break;
              }
              e.chunk = _this13.file.subarray(t, s);
              _context9.next = 15;
              break;
            case 6:
              _context9.prev = 6;
              _context9.next = 9;
              return _this13.file.readChunk(t, s);
            case 9:
              e.chunk = _context9.sent;
              _context9.next = 15;
              break;
            case 12:
              _context9.prev = 12;
              _context9.t0 = _context9["catch"](6);
              l("Couldn't read segment: ".concat(JSON.stringify(e), ". ").concat(_context9.t0.message));
            case 15:
              _context9.next = 18;
              break;
            case 17:
              _this13.file.byteLength > t + s ? e.chunk = _this13.file.subarray(t, s) : void 0 === e.size ? e.chunk = _this13.file.subarray(t) : l("Segment unreachable: " + JSON.stringify(e));
            case 18:
              return _context9.abrupt("return", e.chunk);
            case 19:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[6, 12]]);
      }));
      return function (_x13) {
        return _ref7.apply(this, arguments);
      };
    }()), this.extendOptions && this.extendOptions(t), this.options = t, this.file = s, this.parsers = i;
  }
  _createClass(_class, [{
    key: "injectSegment",
    value: function injectSegment(e, t) {
      this.options[e].enabled && this.createParser(e, t);
    }
  }, {
    key: "createParser",
    value: function createParser(e, t) {
      var s = new (y.get(e))(t, this.options, this.file);
      return this.parsers[e] = s;
    }
  }, {
    key: "createParsers",
    value: function createParsers(e) {
      var _iterator26 = _createForOfIteratorHelper(e),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var _t8 = _step26.value;
          var _e9 = _t8.type,
            s = _t8.chunk,
            i = this.options[_e9];
          if (i && i.enabled) {
            var _t9 = this.parsers[_e9];
            _t9 && _t9.append || _t9 || this.createParser(_e9, s);
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
    }
  }, {
    key: "readSegments",
    value: function () {
      var _readSegments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(e) {
        var t;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              t = e.map(this.ensureSegmentChunk);
              _context10.next = 3;
              return Promise.all(t);
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function readSegments(_x14) {
        return _readSegments.apply(this, arguments);
      }
      return readSegments;
    }()
  }]);
  return _class;
}());
e(ee, "type", "jpeg"), m.set("jpeg", ee);
var te = [void 0, 1, 1, 2, 4, 8, 1, 1, 2, 4, 8, 4, 8, 4];
var se = /*#__PURE__*/function (_J) {
  _inherits(se, _J);
  function se() {
    _classCallCheck(this, se);
    return _callSuper(this, se, arguments);
  }
  _createClass(se, [{
    key: "parseHeader",
    value: function parseHeader() {
      var e = this.chunk.getUint16();
      18761 === e ? this.le = !0 : 19789 === e && (this.le = !1), this.chunk.le = this.le, this.headerParsed = !0;
    }
  }, {
    key: "parseTags",
    value: function parseTags(e, t) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Map();
      var _this$options$t = this.options[t],
        i = _this$options$t.pick,
        n = _this$options$t.skip;
      i = new Set(i);
      var r = i.size > 0,
        a = 0 === n.size,
        h = this.chunk.getUint16(e);
      e += 2;
      for (var _f = 0; _f < h; _f++) {
        var _h = this.chunk.getUint16(e);
        if (r) {
          if (i.has(_h) && (s.set(_h, this.parseTag(e, _h, t)), i.delete(_h), 0 === i.size)) break;
        } else !a && n.has(_h) || s.set(_h, this.parseTag(e, _h, t));
        e += 12;
      }
      return s;
    }
  }, {
    key: "parseTag",
    value: function parseTag(e, t, s) {
      var i = this.chunk,
        n = i.getUint16(e + 2),
        r = i.getUint32(e + 4),
        a = te[n];
      if (a * r <= 4 ? e += 8 : e = i.getUint32(e + 8), (n < 1 || n > 13) && l("Invalid TIFF value type. block: ".concat(s.toUpperCase(), ", tag: ").concat(t.toString(16), ", type: ").concat(n, ", offset ").concat(e)), e > i.byteLength && l("Invalid TIFF value offset. block: ".concat(s.toUpperCase(), ", tag: ").concat(t.toString(16), ", type: ").concat(n, ", offset ").concat(e, " is outside of chunk size ").concat(i.byteLength)), 1 === n) return i.getUint8Array(e, r);
      if (2 === n) return "" === (h = function (e) {
        for (; e.endsWith("\0");) e = e.slice(0, -1);
        return e;
      }(h = i.getString(e, r)).trim()) ? void 0 : h;
      var h;
      if (7 === n) return i.getUint8Array(e, r);
      if (1 === r) return this.parseTagValue(n, e);
      {
        var _t10 = new (function (e) {
            switch (e) {
              case 1:
                return Uint8Array;
              case 3:
                return Uint16Array;
              case 4:
                return Uint32Array;
              case 5:
                return Array;
              case 6:
                return Int8Array;
              case 8:
                return Int16Array;
              case 9:
                return Int32Array;
              case 10:
                return Array;
              case 11:
                return Float32Array;
              case 12:
                return Float64Array;
              default:
                return Array;
            }
          }(n))(r),
          _s10 = a;
        for (var _i18 = 0; _i18 < r; _i18++) _t10[_i18] = this.parseTagValue(n, e), e += _s10;
        return _t10;
      }
    }
  }, {
    key: "parseTagValue",
    value: function parseTagValue(e, t) {
      var s = this.chunk;
      switch (e) {
        case 1:
          return s.getUint8(t);
        case 3:
          return s.getUint16(t);
        case 4:
          return s.getUint32(t);
        case 5:
          return s.getUint32(t) / s.getUint32(t + 4);
        case 6:
          return s.getInt8(t);
        case 8:
          return s.getInt16(t);
        case 9:
          return s.getInt32(t);
        case 10:
          return s.getInt32(t) / s.getInt32(t + 4);
        case 11:
          return s.getFloat(t);
        case 12:
          return s.getDouble(t);
        case 13:
          return s.getUint32(t);
        default:
          l("Invalid tiff type ".concat(e));
      }
    }
  }]);
  return se;
}(J);
var ie = /*#__PURE__*/function (_se) {
  _inherits(ie, _se);
  function ie() {
    _classCallCheck(this, ie);
    return _callSuper(this, ie, arguments);
  }
  _createClass(ie, [{
    key: "parse",
    value: function () {
      var _parse3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var e;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.parseHeader();
              e = this.options;
              _context11.t0 = e.ifd0.enabled;
              if (!_context11.t0) {
                _context11.next = 6;
                break;
              }
              _context11.next = 6;
              return this.parseIfd0Block();
            case 6:
              _context11.t1 = e.exif.enabled;
              if (!_context11.t1) {
                _context11.next = 10;
                break;
              }
              _context11.next = 10;
              return this.safeParse("parseExifBlock");
            case 10:
              _context11.t2 = e.gps.enabled;
              if (!_context11.t2) {
                _context11.next = 14;
                break;
              }
              _context11.next = 14;
              return this.safeParse("parseGpsBlock");
            case 14:
              _context11.t3 = e.interop.enabled;
              if (!_context11.t3) {
                _context11.next = 18;
                break;
              }
              _context11.next = 18;
              return this.safeParse("parseInteropBlock");
            case 18:
              _context11.t4 = e.ifd1.enabled;
              if (!_context11.t4) {
                _context11.next = 22;
                break;
              }
              _context11.next = 22;
              return this.safeParse("parseThumbnailBlock");
            case 22:
              return _context11.abrupt("return", this.createOutput());
            case 23:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function parse() {
        return _parse3.apply(this, arguments);
      }
      return parse;
    }()
  }, {
    key: "safeParse",
    value: function safeParse(e) {
      var t = this[e]();
      return void 0 !== t.catch && (t = t.catch(this.handleError)), t;
    }
  }, {
    key: "findIfd0Offset",
    value: function findIfd0Offset() {
      void 0 === this.ifd0Offset && (this.ifd0Offset = this.chunk.getUint32(4));
    }
  }, {
    key: "findIfd1Offset",
    value: function findIfd1Offset() {
      if (void 0 === this.ifd1Offset) {
        this.findIfd0Offset();
        var _e10 = this.chunk.getUint16(this.ifd0Offset),
          _t11 = this.ifd0Offset + 2 + 12 * _e10;
        this.ifd1Offset = this.chunk.getUint32(_t11);
      }
    }
  }, {
    key: "parseBlock",
    value: function parseBlock(e, t) {
      var s = new Map();
      return this[t] = s, this.parseTags(e, t, s), s;
    }
  }, {
    key: "parseIfd0Block",
    value: function () {
      var _parseIfd0Block = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var e, t;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!this.ifd0) {
                _context12.next = 2;
                break;
              }
              return _context12.abrupt("return");
            case 2:
              e = this.file;
              this.findIfd0Offset();
              this.ifd0Offset < 8 && l("Malformed EXIF data");
              !e.chunked && this.ifd0Offset > e.byteLength && l("IFD0 offset points to outside of file.\nthis.ifd0Offset: ".concat(this.ifd0Offset, ", file.byteLength: ").concat(e.byteLength));
              _context12.t0 = e.tiff;
              if (!_context12.t0) {
                _context12.next = 10;
                break;
              }
              _context12.next = 10;
              return e.ensureChunk(this.ifd0Offset, o(this.options));
            case 10:
              t = this.parseBlock(this.ifd0Offset, "ifd0");
              return _context12.abrupt("return", 0 !== t.size ? (this.exifOffset = t.get(34665), this.interopOffset = t.get(40965), this.gpsOffset = t.get(34853), this.xmp = t.get(700), this.iptc = t.get(33723), this.icc = t.get(34675), this.options.sanitize && (t.delete(34665), t.delete(40965), t.delete(34853), t.delete(700), t.delete(33723), t.delete(34675)), t) : void 0);
            case 12:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function parseIfd0Block() {
        return _parseIfd0Block.apply(this, arguments);
      }
      return parseIfd0Block;
    }()
  }, {
    key: "parseExifBlock",
    value: function () {
      var _parseExifBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var e;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!this.exif) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return");
            case 2:
              _context13.t0 = this.ifd0;
              if (_context13.t0) {
                _context13.next = 6;
                break;
              }
              _context13.next = 6;
              return this.parseIfd0Block();
            case 6:
              if (!(void 0 === this.exifOffset)) {
                _context13.next = 8;
                break;
              }
              return _context13.abrupt("return");
            case 8:
              _context13.t1 = this.file.tiff;
              if (!_context13.t1) {
                _context13.next = 12;
                break;
              }
              _context13.next = 12;
              return this.file.ensureChunk(this.exifOffset, o(this.options));
            case 12:
              e = this.parseBlock(this.exifOffset, "exif");
              return _context13.abrupt("return", (this.interopOffset || (this.interopOffset = e.get(40965)), this.makerNote = e.get(37500), this.userComment = e.get(37510), this.options.sanitize && (e.delete(40965), e.delete(37500), e.delete(37510)), this.unpack(e, 41728), this.unpack(e, 41729), e));
            case 14:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function parseExifBlock() {
        return _parseExifBlock.apply(this, arguments);
      }
      return parseExifBlock;
    }()
  }, {
    key: "unpack",
    value: function unpack(e, t) {
      var s = e.get(t);
      s && 1 === s.length && e.set(t, s[0]);
    }
  }, {
    key: "parseGpsBlock",
    value: function () {
      var _parseGpsBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var e;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!this.gps) {
                _context14.next = 2;
                break;
              }
              return _context14.abrupt("return");
            case 2:
              _context14.t0 = this.ifd0;
              if (_context14.t0) {
                _context14.next = 6;
                break;
              }
              _context14.next = 6;
              return this.parseIfd0Block();
            case 6:
              if (!(void 0 === this.gpsOffset)) {
                _context14.next = 8;
                break;
              }
              return _context14.abrupt("return");
            case 8:
              e = this.parseBlock(this.gpsOffset, "gps");
              return _context14.abrupt("return", (e && e.has(2) && e.has(4) && (e.set("latitude", ne.apply(void 0, _toConsumableArray(e.get(2)).concat([e.get(1)]))), e.set("longitude", ne.apply(void 0, _toConsumableArray(e.get(4)).concat([e.get(3)])))), e));
            case 10:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function parseGpsBlock() {
        return _parseGpsBlock.apply(this, arguments);
      }
      return parseGpsBlock;
    }()
  }, {
    key: "parseInteropBlock",
    value: function () {
      var _parseInteropBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.t0 = !this.interop;
              if (!_context15.t0) {
                _context15.next = 11;
                break;
              }
              _context15.t1 = this.ifd0;
              if (_context15.t1) {
                _context15.next = 6;
                break;
              }
              _context15.next = 6;
              return this.parseIfd0Block();
            case 6:
              _context15.t2 = void 0 !== this.interopOffset || this.exif;
              if (_context15.t2) {
                _context15.next = 10;
                break;
              }
              _context15.next = 10;
              return this.parseExifBlock();
            case 10:
              _context15.t0 = void 0 !== this.interopOffset;
            case 11:
              if (!_context15.t0) {
                _context15.next = 13;
                break;
              }
              return _context15.abrupt("return", this.parseBlock(this.interopOffset, "interop"));
            case 13:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function parseInteropBlock() {
        return _parseInteropBlock.apply(this, arguments);
      }
      return parseInteropBlock;
    }()
  }, {
    key: "parseThumbnailBlock",
    value: function () {
      var _parseThumbnailBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var e,
          _args16 = arguments;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              e = _args16.length > 0 && _args16[0] !== undefined ? _args16[0] : !1;
              if (!(!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || e))) {
                _context16.next = 3;
                break;
              }
              return _context16.abrupt("return", (this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = !0), this.ifd1));
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function parseThumbnailBlock() {
        return _parseThumbnailBlock.apply(this, arguments);
      }
      return parseThumbnailBlock;
    }()
  }, {
    key: "extractThumbnail",
    value: function () {
      var _extractThumbnail2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var e, t;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              this.headerParsed || this.parseHeader();
              _context17.t0 = this.ifd1Parsed;
              if (_context17.t0) {
                _context17.next = 5;
                break;
              }
              _context17.next = 5;
              return this.parseThumbnailBlock(!0);
            case 5:
              if (!(void 0 === this.ifd1)) {
                _context17.next = 7;
                break;
              }
              return _context17.abrupt("return");
            case 7:
              e = this.ifd1.get(513), t = this.ifd1.get(514);
              return _context17.abrupt("return", this.chunk.getUint8Array(e, t));
            case 9:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function extractThumbnail() {
        return _extractThumbnail2.apply(this, arguments);
      }
      return extractThumbnail;
    }()
  }, {
    key: "image",
    get: function get() {
      return this.ifd0;
    }
  }, {
    key: "thumbnail",
    get: function get() {
      return this.ifd1;
    }
  }, {
    key: "createOutput",
    value: function createOutput() {
      var e,
        t,
        s,
        i = {};
      for (var _i19 = 0, _P3 = P; _i19 < _P3.length; _i19++) {
        t = _P3[_i19];
        if (e = this[t], !f(e)) if (s = this.canTranslate ? this.translateBlock(e, t) : Object.fromEntries(e), this.options.mergeOutput) {
          if ("ifd1" === t) continue;
          Object.assign(i, s);
        } else i[t] = s;
      }
      return this.makerNote && (i.makerNote = this.makerNote), this.userComment && (i.userComment = this.userComment), i;
    }
  }, {
    key: "assignToOutput",
    value: function assignToOutput(e, t) {
      if (this.globalOptions.mergeOutput) Object.assign(e, t);else for (var _i20 = 0, _Object$entries = Object.entries(t); _i20 < _Object$entries.length; _i20++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i20], 2),
          s = _Object$entries$_i[0],
          i = _Object$entries$_i[1];
        this.assignObjectToOutput(e, s, i);
      }
    }
  }], [{
    key: "canHandle",
    value: function canHandle(e, t) {
      return 225 === e.getUint8(t + 1) && 1165519206 === e.getUint32(t + 4) && 0 === e.getUint16(t + 8);
    }
  }]);
  return ie;
}(se);
function ne(e, t, s, i) {
  var n = e + t / 60 + s / 3600;
  return "S" !== i && "W" !== i || (n *= -1), n;
}
e(ie, "type", "tiff"), e(ie, "headerLength", 10), y.set("tiff", ie);
var re = Object.freeze({
  __proto__: null,
  default: G,
  Exifr: H,
  fileParsers: m,
  segmentParsers: y,
  fileReaders: b,
  tagKeys: B,
  tagValues: V,
  tagRevivers: I,
  createDictionary: x,
  extendDictionary: C,
  fetchUrlAsArrayBuffer: S,
  readBlobAsArrayBuffer: A,
  chunkedProps: L,
  otherSegments: T,
  segments: z,
  tiffBlocks: P,
  segmentsAndBlocks: F,
  tiffExtractables: j,
  inheritables: E,
  allFormatters: M,
  Options: R,
  parse: Y
});
var ae = {
    ifd0: !1,
    ifd1: !1,
    exif: !1,
    gps: !1,
    interop: !1,
    sanitize: !1,
    reviveValues: !0,
    translateKeys: !1,
    translateValues: !1,
    mergeOutput: !1
  },
  he = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    gps: [1, 2, 3, 4]
  });
function fe(_x15) {
  return _fe.apply(this, arguments);
}
function _fe() {
  _fe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(e) {
    var t, s, _s$gps, _e15, _t17;
    return _regeneratorRuntime().wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          t = new H(he);
          _context29.next = 3;
          return t.read(e);
        case 3:
          _context29.next = 5;
          return t.parse();
        case 5:
          s = _context29.sent;
          if (!(s && s.gps)) {
            _context29.next = 9;
            break;
          }
          _s$gps = s.gps, _e15 = _s$gps.latitude, _t17 = _s$gps.longitude;
          return _context29.abrupt("return", {
            latitude: _e15,
            longitude: _t17
          });
        case 9:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return _fe.apply(this, arguments);
}
var le = Object.assign({}, ae, {
  tiff: !1,
  ifd1: !0,
  mergeOutput: !1
});
function oe(_x16) {
  return _oe.apply(this, arguments);
}
function _oe() {
  _oe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(e) {
    var t, s;
    return _regeneratorRuntime().wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          t = new H(le);
          _context30.next = 3;
          return t.read(e);
        case 3:
          _context30.next = 5;
          return t.extractThumbnail();
        case 5:
          s = _context30.sent;
          return _context30.abrupt("return", s && a ? r.from(s) : s);
        case 7:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return _oe.apply(this, arguments);
}
function ue(_x17) {
  return _ue.apply(this, arguments);
}
function _ue() {
  _ue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(e) {
    var t, _e16;
    return _regeneratorRuntime().wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 2;
          return this.thumbnail(e);
        case 2:
          t = _context31.sent;
          if (!(void 0 !== t)) {
            _context31.next = 6;
            break;
          }
          _e16 = new Blob([t]);
          return _context31.abrupt("return", URL.createObjectURL(_e16));
        case 6:
        case "end":
          return _context31.stop();
      }
    }, _callee31, this);
  }));
  return _ue.apply(this, arguments);
}
var de = Object.assign({}, ae, {
  firstChunkSize: 4e4,
  ifd0: [274]
});
function ce(_x18) {
  return _ce.apply(this, arguments);
}
function _ce() {
  _ce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(e) {
    var t, s;
    return _regeneratorRuntime().wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          t = new H(de);
          _context32.next = 3;
          return t.read(e);
        case 3:
          _context32.next = 5;
          return t.parse();
        case 5:
          s = _context32.sent;
          if (!(s && s.ifd0)) {
            _context32.next = 8;
            break;
          }
          return _context32.abrupt("return", s.ifd0[274]);
        case 8:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return _ce.apply(this, arguments);
}
var pe = Object.freeze({
  1: {
    dimensionSwapped: !1,
    scaleX: 1,
    scaleY: 1,
    deg: 0,
    rad: 0
  },
  2: {
    dimensionSwapped: !1,
    scaleX: -1,
    scaleY: 1,
    deg: 0,
    rad: 0
  },
  3: {
    dimensionSwapped: !1,
    scaleX: 1,
    scaleY: 1,
    deg: 180,
    rad: 180 * Math.PI / 180
  },
  4: {
    dimensionSwapped: !1,
    scaleX: -1,
    scaleY: 1,
    deg: 180,
    rad: 180 * Math.PI / 180
  },
  5: {
    dimensionSwapped: !0,
    scaleX: 1,
    scaleY: -1,
    deg: 90,
    rad: 90 * Math.PI / 180
  },
  6: {
    dimensionSwapped: !0,
    scaleX: 1,
    scaleY: 1,
    deg: 90,
    rad: 90 * Math.PI / 180
  },
  7: {
    dimensionSwapped: !0,
    scaleX: 1,
    scaleY: -1,
    deg: 270,
    rad: 270 * Math.PI / 180
  },
  8: {
    dimensionSwapped: !0,
    scaleX: 1,
    scaleY: 1,
    deg: 270,
    rad: 270 * Math.PI / 180
  }
});
var ge = !0,
  me = !0;
if ("object" == (typeof navigator === "undefined" ? "undefined" : _typeof(navigator))) {
  var _e11 = navigator.userAgent;
  if (_e11.includes("iPad") || _e11.includes("iPhone")) {
    var _t12 = _e11.match(/OS (\d+)_(\d+)/);
    if (_t12) {
      var _t13 = _slicedToArray(_t12, 3),
        _e12 = _t13[1],
        s = _t13[2],
        i = Number(_e12) + .1 * Number(s);
      ge = i < 13.4, me = !1;
    }
  } else if (_e11.includes("OS X 10")) {
    var _e11$match = _e11.match(/OS X 10[_.](\d+)/),
      _e11$match2 = _slicedToArray(_e11$match, 2),
      _t14 = _e11$match2[1];
    ge = me = Number(_t14) < 15;
  }
  if (_e11.includes("Chrome/")) {
    var _e11$match3 = _e11.match(/Chrome\/(\d+)/),
      _e11$match4 = _slicedToArray(_e11$match3, 2),
      _t15 = _e11$match4[1];
    ge = me = Number(_t15) < 81;
  } else if (_e11.includes("Firefox/")) {
    var _e11$match5 = _e11.match(/Firefox\/(\d+)/),
      _e11$match6 = _slicedToArray(_e11$match5, 2),
      _t16 = _e11$match6[1];
    ge = me = Number(_t16) < 77;
  }
}
function ye(_x19) {
  return _ye.apply(this, arguments);
}
function _ye() {
  _ye = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(e) {
    var t;
    return _regeneratorRuntime().wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          _context33.next = 2;
          return ce(e);
        case 2:
          t = _context33.sent;
          return _context33.abrupt("return", Object.assign({
            canvas: ge,
            css: me
          }, pe[t]));
        case 4:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return _ye.apply(this, arguments);
}
var be = /*#__PURE__*/function (_c) {
  _inherits(be, _c);
  function be() {
    var _this14;
    _classCallCheck(this, be);
    for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      t[_key2] = arguments[_key2];
    }
    _this14 = _callSuper(this, be, [].concat(t)), e(_assertThisInitialized(_this14), "ranges", new we()), 0 !== _this14.byteLength && _this14.ranges.add(0, _this14.byteLength);
    return _this14;
  }
  _createClass(be, [{
    key: "_tryExtend",
    value: function _tryExtend(e, t, s) {
      if (0 === e && 0 === this.byteLength && s) {
        var _e13 = new DataView(s.buffer || s, s.byteOffset, s.byteLength);
        this._swapDataView(_e13);
      } else {
        var _s11 = e + t;
        if (_s11 > this.byteLength) {
          var _this$_extend = this._extend(_s11),
            _e14 = _this$_extend.dataView;
          this._swapDataView(_e14);
        }
      }
    }
  }, {
    key: "_extend",
    value: function _extend(e) {
      var t;
      t = a ? r.allocUnsafe(e) : new Uint8Array(e);
      var s = new DataView(t.buffer, t.byteOffset, t.byteLength);
      return t.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), {
        uintView: t,
        dataView: s
      };
    }
  }, {
    key: "subarray",
    value: function subarray(e, t) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return t = t || this._lengthToEnd(e), s && this._tryExtend(e, t), this.ranges.add(e, t), _get(_getPrototypeOf(be.prototype), "subarray", this).call(this, e, t);
    }
  }, {
    key: "set",
    value: function set(e, t) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      s && this._tryExtend(t, e.byteLength, e);
      var i = _get(_getPrototypeOf(be.prototype), "set", this).call(this, e, t);
      return this.ranges.add(t, i.byteLength), i;
    }
  }, {
    key: "ensureChunk",
    value: function () {
      var _ensureChunk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(e, t) {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.t0 = this.chunked;
              if (!_context18.t0) {
                _context18.next = 6;
                break;
              }
              _context18.t1 = this.ranges.available(e, t);
              if (_context18.t1) {
                _context18.next = 6;
                break;
              }
              _context18.next = 6;
              return this.readChunk(e, t);
            case 6:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function ensureChunk(_x20, _x21) {
        return _ensureChunk.apply(this, arguments);
      }
      return ensureChunk;
    }()
  }, {
    key: "available",
    value: function available(e, t) {
      return this.ranges.available(e, t);
    }
  }]);
  return be;
}(c);
var we = /*#__PURE__*/function () {
  function we() {
    _classCallCheck(this, we);
    e(this, "list", []);
  }
  _createClass(we, [{
    key: "length",
    get: function get() {
      return this.list.length;
    }
  }, {
    key: "add",
    value: function add(e, t) {
      var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var i = e + t,
        n = this.list.filter(function (t) {
          return ke(e, t.offset, i) || ke(e, t.end, i);
        });
      if (n.length > 0) {
        e = Math.min.apply(Math, [e].concat(_toConsumableArray(n.map(function (e) {
          return e.offset;
        })))), i = Math.max.apply(Math, [i].concat(_toConsumableArray(n.map(function (e) {
          return e.end;
        })))), t = i - e;
        var _s12 = n.shift();
        _s12.offset = e, _s12.length = t, _s12.end = i, this.list = this.list.filter(function (e) {
          return !n.includes(e);
        });
      } else this.list.push({
        offset: e,
        length: t,
        end: i
      });
    }
  }, {
    key: "available",
    value: function available(e, t) {
      var s = e + t;
      return this.list.some(function (t) {
        return t.offset <= e && s <= t.end;
      });
    }
  }]);
  return we;
}();
function ke(e, t, s) {
  return e <= t && t <= s;
}
var Oe = /*#__PURE__*/function (_be) {
  _inherits(Oe, _be);
  function Oe(t, s) {
    var _this15;
    _classCallCheck(this, Oe);
    _this15 = _callSuper(this, Oe, [0]), e(_assertThisInitialized(_this15), "chunksRead", 0), _this15.input = t, _this15.options = s;
    return _this15;
  }
  _createClass(Oe, [{
    key: "readWhole",
    value: function () {
      var _readWhole = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              this.chunked = !1;
              _context19.next = 3;
              return this.readChunk(this.nextChunkOffset);
            case 3:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function readWhole() {
        return _readWhole.apply(this, arguments);
      }
      return readWhole;
    }()
  }, {
    key: "readChunked",
    value: function () {
      var _readChunked = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              this.chunked = !0;
              _context20.next = 3;
              return this.readChunk(0, this.options.firstChunkSize);
            case 3:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function readChunked() {
        return _readChunked.apply(this, arguments);
      }
      return readChunked;
    }()
  }, {
    key: "readNextChunk",
    value: function () {
      var _readNextChunk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var e,
          t,
          s,
          _args21 = arguments;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              e = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : this.nextChunkOffset;
              if (!this.fullyRead) {
                _context21.next = 3;
                break;
              }
              return _context21.abrupt("return", (this.chunksRead++, !1));
            case 3:
              t = this.options.chunkSize;
              _context21.next = 6;
              return this.readChunk(e, t);
            case 6:
              s = _context21.sent;
              return _context21.abrupt("return", !!s && s.byteLength === t);
            case 8:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function readNextChunk() {
        return _readNextChunk.apply(this, arguments);
      }
      return readNextChunk;
    }()
  }, {
    key: "readChunk",
    value: function () {
      var _readChunk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(e, t) {
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (!(this.chunksRead++, 0 !== (t = this.safeWrapAddress(e, t)))) {
                _context22.next = 2;
                break;
              }
              return _context22.abrupt("return", this._readChunk(e, t));
            case 2:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function readChunk(_x22, _x23) {
        return _readChunk.apply(this, arguments);
      }
      return readChunk;
    }()
  }, {
    key: "safeWrapAddress",
    value: function safeWrapAddress(e, t) {
      return void 0 !== this.size && e + t > this.size ? Math.max(0, this.size - e) : t;
    }
  }, {
    key: "nextChunkOffset",
    get: function get() {
      if (0 !== this.ranges.list.length) return this.ranges.list[0].length;
    }
  }, {
    key: "canReadNextChunk",
    get: function get() {
      return this.chunksRead < this.options.chunkLimit;
    }
  }, {
    key: "fullyRead",
    get: function get() {
      return void 0 !== this.size && this.nextChunkOffset === this.size;
    }
  }, {
    key: "read",
    value: function read() {
      return this.options.chunked ? this.readChunked() : this.readWhole();
    }
  }, {
    key: "close",
    value: function close() {}
  }]);
  return Oe;
}(be);
b.set("blob", /*#__PURE__*/function (_Oe) {
  _inherits(_class2, _Oe);
  function _class2() {
    _classCallCheck(this, _class2);
    return _callSuper(this, _class2, arguments);
  }
  _createClass(_class2, [{
    key: "readWhole",
    value: function () {
      var _readWhole2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var e;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              this.chunked = !1;
              _context23.next = 3;
              return A(this.input);
            case 3:
              e = _context23.sent;
              this._swapArrayBuffer(e);
            case 5:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function readWhole() {
        return _readWhole2.apply(this, arguments);
      }
      return readWhole;
    }()
  }, {
    key: "readChunked",
    value: function readChunked() {
      return this.chunked = !0, this.size = this.input.size, _get(_getPrototypeOf(_class2.prototype), "readChunked", this).call(this);
    }
  }, {
    key: "_readChunk",
    value: function () {
      var _readChunk2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(e, t) {
        var s, i, n;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              s = t ? e + t : void 0;
              i = this.input.slice(e, s);
              _context24.next = 4;
              return A(i);
            case 4:
              n = _context24.sent;
              return _context24.abrupt("return", this.set(n, e, !0));
            case 6:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function _readChunk(_x24, _x25) {
        return _readChunk2.apply(this, arguments);
      }
      return _readChunk;
    }()
  }]);
  return _class2;
}(Oe));
export default re;
export { H as Exifr, R as Options, M as allFormatters, L as chunkedProps, x as createDictionary, C as extendDictionary, S as fetchUrlAsArrayBuffer, m as fileParsers, b as fileReaders, fe as gps, he as gpsOnlyOptions, E as inheritables, ce as orientation, de as orientationOnlyOptions, T as otherSegments, Y as parse, A as readBlobAsArrayBuffer, ge as rotateCanvas, me as rotateCss, ye as rotation, pe as rotations, y as segmentParsers, z as segments, F as segmentsAndBlocks, B as tagKeys, I as tagRevivers, V as tagValues, oe as thumbnail, le as thumbnailOnlyOptions, ue as thumbnailUrl, P as tiffBlocks, j as tiffExtractables };